import 'src/styles/ui/pagination.css';

import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

import Select from './Select';

const Pagination = ({
  className,
  currentPage,
  totalPages,
  onPageChange,
  pageSize,
  onPageSizeChange,
  pageSizeOptions = [10, 25, 50, 100],
}) => {
  return (
    <div className={`pagination ${className}`}>
      <div className='pagination__buttons' style={{ fontsize: '14px' }}>
        <button
          type='button'
          className='button button--icon button--sm button--square'
          disabled={currentPage === 1}
          aria-label='Previous page'
          onClick={() => onPageChange(currentPage - 1)}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        Page {currentPage} of {totalPages}
        <button
          type='button'
          className='button button--icon button--sm button--square'
          disabled={currentPage === totalPages}
          aria-label='Next page'
          onClick={() => onPageChange(currentPage + 1)}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>
      <div className='pagination__control'>
        <Select
          name='currentPageSelect'
          value={currentPage}
          disabled={totalPages <= 1}
          onChange={e => onPageChange(Number(e.target.value))}
        >
          {Array.from({ length: totalPages }, (_, i) => (
            <option key={i + 1} value={i + 1}>
              {i + 1}
            </option>
          ))}
        </Select>
        <Select
          name='pageSizeSelect'
          value={pageSize}
          onChange={e => onPageSizeChange(Number(e.target.value))}
        >
          {pageSizeOptions.map(size => (
            <option key={size} value={size}>
              Show {size}
            </option>
          ))}
        </Select>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  className: PropTypes.string,
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
};

export default Pagination;
